import { createContext, useContext, useState, ReactNode } from "react";
import { ComponentMetadata } from "../pages/configurations/component-lead/types/component";

type ComponentContextType = {
  componentsData: Record<string, ComponentMetadata>;
  updateComponent: (id: string, data: ComponentMetadata) => void;
};

const ComponentContext = createContext<ComponentContextType | undefined>(
  undefined,
);

export const ComponentProvider = ({ children }: { children: ReactNode }) => {
  const [componentsData, setComponentsData] = useState<
    Record<string, ComponentMetadata>
  >({
    // Bookings
    bookings: {
      componentName: "Bookings",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    churchBookings: {
      componentName: "Church Bookings",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    funeralBookings: {
      componentName: "Funeral Bookings",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    funeralHomeBookings: {
      componentName: "Funeral Home Bookings",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    otherBookings: {
      componentName: "Other Bookings",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    conferenceBookings: {
      componentName: "Conference Bookings",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    eventBookings: {
      componentName: "Event Bookings",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },

    // Dashboard
    dashboard: {
      componentName: "Dashboard",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    mainDashboard: {
      componentName: "Main Dashboard",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    clientPortalDashboard: {
      componentName: "Client Portal Dashboard",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },

    // Stream Management
    streamManagement: {
      componentName: "Stream Management",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    addStream: {
      componentName: "Add Stream",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    viewStream: {
      componentName: "View Stream",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    editStream: {
      componentName: "Edit Stream",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    streamReport: {
      componentName: "Stream Report",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    callSheet: {
      componentName: "Call Sheet",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    tenDayForecast: {
      componentName: "10-Day Forecast",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },

    // Venues
    venues: {
      componentName: "Venues",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    addVenue: {
      componentName: "Add Venue",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    viewVenue: {
      componentName: "View Venue",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    editVenue: {
      componentName: "Edit Venue",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },

    // Contacts
    contacts: {
      componentName: "Contacts",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    addCompanyContact: {
      componentName: "Add Company Contact",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    addIndividualContact: {
      componentName: "Add Individual Contact",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    companyView: {
      componentName: "Company View",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    individualView: {
      componentName: "Individual View",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    editCompany: {
      componentName: "Edit Company Contact",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    editIndividual: {
      componentName: "Edit Individual Contact",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },

    // Companies
    companies: {
      componentName: "Companies",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    addCompany: {
      componentName: "Add Company",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    viewCompany: {
      componentName: "View Company",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    editCompanyForm: {
      componentName: "Edit Company",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },

    // Crew Management
    crewManagement: {
      componentName: "Crew Management",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    allCrew: {
      componentName: "All Crew",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    checklists: {
      componentName: "Checklists",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    viewChecklist: {
      componentName: "View Checklist",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    crewRatings: {
      componentName: "Crew Ratings",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    rateCards: {
      componentName: "Rate Cards",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    viewCrewMember: {
      componentName: "View Crew Member",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    viewChecklistItems: {
      componentName: "View Checklist Items",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },

    // Gear, Sales, Settings
    gearManagement: {
      componentName: "Gear Management",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    sales: {
      componentName: "Sales",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
    settings: {
      componentName: "Settings",
      description: "",
      leadName: "",
      backupDeveloper: "",
      version: "",
    },
  });

  const updateComponent = (id: string, newData: ComponentMetadata) => {
    setComponentsData((prev) => ({
      ...prev,
      [id]: { ...prev[id], ...newData },
    }));
  };

  return (
    <ComponentContext.Provider value={{ componentsData, updateComponent }}>
      {children}
    </ComponentContext.Provider>
  );
};

export const useComponentContext = () => {
  const context = useContext(ComponentContext);
  if (!context)
    throw new Error(
      "useComponentContext must be used inside ComponentProvider",
    );
  return context;
};
